webpackJsonp([199700796789862],{

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  position: relative;\n"], ["\n  background-color: ", ";\n  position: relative;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(14);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _ContentBlock = __webpack_require__(62);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CtaWrapper = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.colors.blue;
	});
	
	var Cta = function Cta(props) {
	  return _react2.default.createElement(
	    CtaWrapper,
	    null,
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(_ContentBlock2.default, {
	        smallMargin: true,
	        fullWidth: true,
	        diapositive: true,
	        title: props.cta[0].node.title,
	        src: props.cta[0].node.buttonUrl.childMarkdownRemark.rawMarkdownBody,
	        buttonText: props.cta[0].node.buttonText
	      })
	    )
	  );
	};
	
	exports.default = Cta;
	module.exports = exports["default"];

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  p {\n    line-height: 1.5;\n    color: ', ';\n    margin-bottom: 2rem;\n\n    > p {\n      border-left: none;\n      padding-left: none;\n      max-width: none;\n    }\n  }\n'], ['\n  p {\n    line-height: 1.5;\n    color: ', ';\n    margin-bottom: 2rem;\n\n    > p {\n      border-left: none;\n      padding-left: none;\n      max-width: none;\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  @media (min-width: ', ') {\n    padding: 3em 6em;\n  }\n'], ['\n  @media (min-width: ', ') {\n    padding: 3em 6em;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  box-shadow: -6px 8px 25px 0 rgba(0, 0, 0, 0.5);\n  z-index: 1;\n  width: 100%;\n  position: relative;\n  margin-bottom: 2em;\n\n  img {\n    object-fit: ', ' !important;\n    object-position: ', ' !important;\n    font-family: \'object-fit: ', ' !important; object-position: ', ' !important;\'\n  }\n\n  &::after {\n    content: "";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ', ';\n    mix-blend-mode: multiply;\n    opacity: 0;\n\n    @supports (mix-blend-mode: multiply) {\n      opacity: 1;\n    }\n  }\n  &::before {\n    content: "";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ', ';\n    mix-blend-mode: screen;\n    opacity: 0.5;\n    z-index: 1;\n\n    @supports (mix-blend-mode: multiply) {\n      opacity: 1;\n    }\n  }\n\n  div {\n    height: 100%;\n  }\n'], ['\n  box-shadow: -6px 8px 25px 0 rgba(0, 0, 0, 0.5);\n  z-index: 1;\n  width: 100%;\n  position: relative;\n  margin-bottom: 2em;\n\n  img {\n    object-fit: ', ' !important;\n    object-position: ', ' !important;\n    font-family: \'object-fit: ', ' !important; object-position: ', ' !important;\'\n  }\n\n  &::after {\n    content: "";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ', ';\n    mix-blend-mode: multiply;\n    opacity: 0;\n\n    @supports (mix-blend-mode: multiply) {\n      opacity: 1;\n    }\n  }\n  &::before {\n    content: "";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ', ';\n    mix-blend-mode: screen;\n    opacity: 0.5;\n    z-index: 1;\n\n    @supports (mix-blend-mode: multiply) {\n      opacity: 1;\n    }\n  }\n\n  div {\n    height: 100%;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _HeaderSmall = __webpack_require__(47);
	
	var _HeaderSmall2 = _interopRequireDefault(_HeaderSmall);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyImage = __webpack_require__(28);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Container = __webpack_require__(14);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Cta = __webpack_require__(84);
	
	var _Cta2 = _interopRequireDefault(_Cta);
	
	var _Footer = __webpack_require__(31);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	// import { graphql } from 'gatsby'
	
	// import config from '../utils/siteConfig'
	
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	var TextContainer = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.theme.colors.base;
	});
	
	var ContentWrapper = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.theme.responsive.small;
	});
	
	var ImageWrapper = _styledComponents2.default.figure(_templateObject4, function (props) {
	  return props.fit || "cover";
	}, function (props) {
	  return props.position || "50% 50%";
	}, function (props) {
	  return props.fit || "cover";
	}, function (props) {
	  return props.position || "50% 50%";
	}, function (props) {
	  return props.theme.colors.secondary;
	}, function (props) {
	  return props.theme.colors.black;
	});
	
	var PostTemplate = function (_React$Component) {
	  _inherits(PostTemplate, _React$Component);
	
	  function PostTemplate() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PostTemplate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      aboutActive: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PostTemplate.prototype.componentDidMount = function componentDidMount() {
	    this.setState({
	      aboutActive: window.innerWidth < 800 ? false : true
	    });
	  };
	
	  PostTemplate.prototype.render = function render() {
	    var data = this.props.data;
	    var _data$contentfulPost = data.contentfulPost,
	        title = _data$contentfulPost.title,
	        metaDescription = _data$contentfulPost.metaDescription,
	        body = _data$contentfulPost.body,
	        bodyBottom = _data$contentfulPost.bodyBottom,
	        detailImage = _data$contentfulPost.detailImage;
	
	
	    var header = data.allContentfulHeader.edges;
	    var cta = data.allContentfulCta.edges;
	    var posts = data.allContentfulPost.edges;
	
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          title
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: metaDescription })
	      ),
	      _react2.default.createElement(_HeaderSmall2.default, { header: header, title: title, aboutActive: this.state.aboutActive, aboutDetailLinks: posts.map(function (post) {
	          return { slug: post.node.slug, title: post.node.menuTitle };
	        }) }),
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          ContentWrapper,
	          null,
	          _react2.default.createElement(TextContainer, { dangerouslySetInnerHTML: { __html: body.childMarkdownRemark.html } })
	        ),
	        _react2.default.createElement(
	          ImageWrapper,
	          null,
	          _react2.default.createElement(_gatsbyImage2.default, { sizes: detailImage.sizes, alt: detailImage.title, backgroundColor: "#eeeeee" })
	        ),
	        bodyBottom && _react2.default.createElement(
	          ContentWrapper,
	          null,
	          _react2.default.createElement(TextContainer, { dangerouslySetInnerHTML: { __html: bodyBottom.childMarkdownRemark.html } })
	        )
	      ),
	      cta && _react2.default.createElement(_Cta2.default, { cta: cta }),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return PostTemplate;
	}(_react2.default.Component);
	
	;
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = PostTemplate;

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-feature-js-f8a5a6c5afd50c01fc13.js